function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#C11515"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1186 17.3186C20.2074 17.3186 19.326 17.1704 18.5037 16.9037C18.2445 16.8149 17.9556 16.8815 17.7556 17.0815L16.5926 18.5408C14.4963 17.5408 12.5334 15.6519 11.4889 13.4815L12.9334 12.2519C13.1334 12.0445 13.1926 11.7556 13.1111 11.4963C12.8371 10.6741 12.6963 9.79264 12.6963 8.88153C12.6963 8.48153 12.363 8.14819 11.963 8.14819H9.40004C9.00004 8.14819 8.51855 8.32597 8.51855 8.88153C8.51855 15.763 14.2445 21.4815 21.1186 21.4815C21.6445 21.4815 21.8519 21.0149 21.8519 20.6075V18.0519C21.8519 17.6519 21.5186 17.3186 21.1186 17.3186Z",
  fill: "black"
});

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.72160476.svg";
export { ForwardRef as ReactComponent };